export default class CandidateAvailabilityDTO {
  constructor({ id, name, priority, unavailability }) {
    this.id = id
    this.name = name
    this.priority = priority
    this.unavailability = unavailability.map(
      (unavailability) => new UnavailabilityDTO(unavailability)
    )
  }
}

class UnavailabilityDTO {
  constructor({ dateLocal, times }) {
    this.dateLocal = dateLocal
    this.times = times.map((time) => new TimeDTO(time))
  }
}

class TimeDTO {
  constructor({ startTime, endTime }) {
    this.startTime = startTime
    this.endTime = endTime
  }
}
